import ApplicationController from './application_controller'

export default class AlertController extends ApplicationController {
  close() {
    this.element.remove()
  }
}
